module.exports = __webpack_public_path__ + "static/media/Mexico.e5d19000.png";